import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ReportResultsApiResponse, ReportResultRequest } from '../models/results.model';
import { HttpUtils } from '@core/utils/http.utils';

@Injectable({
  providedIn: 'root',
})
export class ResultsApi {
  private readonly http = inject(HttpClient);
  private readonly REPORT_RESULTS = '/Results';


  getReportResults(request: ReportResultRequest): Observable<ReportResultsApiResponse> {
    const url = `${this.REPORT_RESULTS}`;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get<ReportResultsApiResponse>(url, { params })
      .pipe(map((data: ReportResultsApiResponse) => {
        return {...data}
      }));
  }

}
